import { toast } from 'vue3-toastify';
import { fileCategories } from '@/assets/js/constants.js';

function get_sources_color(matching_percentage, bg_color = false) {
    if (matching_percentage === 0) {
        return !bg_color ? 'error' : 'text-error bg-red-lighten-5';
    } else if (matching_percentage > 0 && matching_percentage < 0.75) {
        return !bg_color ? 'primary' : 'text-primary';
    } else {
        return !bg_color ? 'success' : 'text-success bg-green-lighten-5';
    }
}

function getFileExtension(filename) {
    const normalizedFilename = filename.trim().toLowerCase();
    const lastDotIndex = normalizedFilename.lastIndexOf('.');

    if (lastDotIndex <= 0 || lastDotIndex === normalizedFilename.length - 1) {
        return null;
    }

    const extension = normalizedFilename.substring(lastDotIndex + 1);
    return extension;
}

function getFileCategory(file) {
    const extension = getFileExtension(file);
    if (!extension) {
        return 'unkown';
    }

    for (const category in fileCategories) {
        if (fileCategories[category].includes(extension)) {
            return category;
        }
    }

    return 'unkown';
}

function defaultErrorHandling({ msg = undefined } = {}) {
    return function innerFunction(err) {
        let error_content = JSON.stringify(err);
        console.error(err);
        if (err?.response?.data?.detail) {
            let error_content =
                err.response.status === 422
                    ? JSON.stringify(err.response.data.detail)
                    : err.response.data.detail;

            if (err.response.status === 422) {
                error_content = error_content.replace(/['"]+/g, '');
                toast.error("It seems you've entered invalid data. Please check and try again.");
            } else {
                if (msg) {
                    error_content = msg + ' ' + error_content;
                }
                toast.error(error_content);
            }
            return null;
        } else {
            console.log('error');
            if (msg) {
                error_content = msg + ' ' + 'Something went wrong. Reload the page and try again.';
            } else {
                error_content = 'Something went wrong. Reload the page and try again.';
            }
            toast.error(error_content);
            return null;
        }
    };
}

export { get_sources_color, getFileExtension, defaultErrorHandling, getFileCategory };
